'use strict';
module.exports = false;



/*****************
 ** WEBPACK FOOTER
 ** ./~/supports-color/browser.js
 ** module id = 1719
 ** module chunks = 0
 **/